import React from 'react';
import { Modal } from '../../ui/Modal';
import { Button } from '../../ui/Button';
interface ProspectConfirmModalProps {
  companyName: string | null;
  onKeep: () => void;
  onActivate: () => void;
}
export function ProspectConfirmModal({
  companyName,
  onKeep,
  onActivate
}: ProspectConfirmModalProps) {
  return <Modal isOpen={Boolean(companyName)} onClose={onKeep} title="Cliente prospect" size="md" data-id="element-1511" data-mp="i50hk5anwiaa">
      <p className="text-sm text-slate-600" data-id="element-1512" data-mp="vvn8hba6l3vt">
        <span className="font-semibold text-slate-800" data-id="element-1513" data-mp="rweec5b8b3zq">{companyName}</span>{' '}
        risulta <span className="font-medium" data-id="element-1514" data-mp="15vmjdeu2p6bu">prospect</span> in anagrafica.
        Vuoi passarlo allo stato <span className="font-medium" data-id="element-1515" data-mp="10wjm4gkc44ef">attivo</span>?
      </p>
      <div className="flex justify-end gap-3 pt-6" data-id="element-1516" data-mp="10x2ryywpn2c3">
        <Button variant="flat" color="default" onClick={onKeep} data-id="element-1517" data-mp="37mr9u7k9s0ul">
          Lascia prospect
        </Button>
        <Button onClick={onActivate} data-id="element-1518" data-mp="32ofzlvq2bobu">Passa ad attivo</Button>
      </div>
    </Modal>;
}